import {
  Control,
  FieldErrors,
  UseFormGetValues,
  UseFormRegister,
} from "react-hook-form";

import { ConsultationCompletionDataInputType } from "~/providers/utils";
import {
  CompletedMultiCheckAnswer,
  MultiCheckQuestionData,
} from "~/providers/utils/mentalStatusExaminations/interfaces";
import { mentalStatusExaminationsQuestions } from "~/providers/utils/mentalStatusExaminations/mentalStatusExaminationsQuestions";
import { MentalStatusExaminationsQuestions } from "~/providers/utils/mentalStatusExaminations/questionData";
import { MentalStatusExaminationForm } from "./MentalStatusExaminationForm";

interface MentalStatusExaminationProps {
  getValues: UseFormGetValues<ConsultationCompletionDataInputType>;
  register: UseFormRegister<ConsultationCompletionDataInputType>;
  errors: FieldErrors<ConsultationCompletionDataInputType>;
  control: Control<ConsultationCompletionDataInputType>;
  isDisabled: boolean;
}

export const MentalStatusExamination = ({
  getValues,
  register,
  errors,
  control,
  isDisabled,
}: MentalStatusExaminationProps) => {
  return (
    <div className="grid gap-x-8 gap-y-4 md:grid-cols-3 xl:w-fit xl:grid-cols-[repeat(3,minmax(260px,1fr))]">
      {mentalStatusExaminationsQuestions.map((question) => {
        const completedAnswer = getValues(
          `data.${question.key as MentalStatusExaminationsQuestions}`,
        );

        return (
          <MentalStatusExaminationForm
            key={question.key}
            question={question as MultiCheckQuestionData}
            completedAnswer={completedAnswer as CompletedMultiCheckAnswer}
            getValues={getValues}
            register={register}
            errors={errors}
            control={control}
            isDisabledForm={isDisabled}
          />
        );
      })}
    </div>
  );
};
